import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import './Dashboard.css';

const Perfil = () => {
  const navigate = useNavigate();
  const isLocal = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
  const apiBase = isLocal ? `http://${window.location.hostname}:3001` : `https://${window.location.hostname}`;
  const [user, setUser] = useState(null);
  const [isRecovering, setIsRecovering] = useState(false);
  const [mensaje, setMensaje] = useState('');

  const handleLogout = () => {
    localStorage.removeItem('user');
    navigate('/');
  };

  useEffect(() => {
    const savedUser = localStorage.getItem('user');
    if (!savedUser) return navigate('/');
    setUser(JSON.parse(savedUser));
  }, [navigate]);

  const handleSolicitarCambio = async (e) => {
    e.preventDefault();
    setIsRecovering(true);
    setMensaje('');
    try {
      const resp = await fetch(`${apiBase}/api/perfil/recuperar`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ rut: user.rut })
      });
      const data = await resp.json();
      if (resp.ok) {
        setMensaje(data.message);
      } else {
        alert('Error: ' + data.error);
      }
    } catch(err) {
      alert('Error de conexión con el servidor.');
    } finally {
      setIsRecovering(false);
    }
  };

  if (!user) return null;

  return (
    <div className="dashboard-layout">
      <aside className="sidebar">
        <div className="sidebar-header">
          <h2>Gestor de Equipos</h2>
        </div>
        <nav className="sidebar-nav">
          {user.rol === 'supervisor' ? (
            <Link to="/supervisor" className="nav-item">Panel de Análisis</Link>
          ) : (
            <>
              <Link to="/dashboard" className="nav-item">Equipos</Link>
              <Link to="/funcionarios" className="nav-item">Funcionarios</Link>
              {(user.rol === 'admin' || user.rol === 'superadmin') && (
                <>
                  <Link to="/supervisor" className="nav-item">Panel de Análisis</Link>
                  <Link to="/usuarios" className="nav-item">Usuarios (Admin)</Link>
                </>
              )}
            </>
          )}
        </nav>
        <div className="sidebar-footer">
          <button onClick={handleLogout} className="btn-logout-premium" style={{ width: 'calc(100% - 20px)', marginLeft: '10px' }}>
            Cerrar Sesión
          </button>
        </div>
      </aside>

      <main className="main-content">
        <header className="content-header">
          <h1>Mi Perfil de Usuario</h1>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <div className="user-profile" style={{ marginRight: '0' }}>
              <span>{user.nombre}</span>
              <div className="avatar" style={{background: '#20c997'}}>{user.nombre.charAt(0).toUpperCase()}</div>
            </div>
            <button className="btn-logout-premium" onClick={handleLogout}>
              Cerrar Sesión
            </button>
          </div>
        </header>

        {user.primer_ingreso === 1 && (
          <div style={{margin: '20px 0', padding: '18px 22px', background: '#fff3cd', border: '1px solid #ffc107', borderLeft: '5px solid #ff9800', borderRadius: '8px', display: 'flex', alignItems: 'center', gap: '14px'}}>
            <div style={{fontWeight: 'bold', fontSize: '18px', color: '#856404'}}>AVISO:</div>
            <div>
              <strong style={{display: 'block', color: '#856404', fontSize: '15px'}}>Acceso Temporal — Debes cambiar tu contraseña</strong>
              <span style={{color: '#856404', fontSize: '13px', lineHeight: '1.5'}}>Es tu primer ingreso al sistema. Por seguridad, solicita el enlace de cambio de contraseña aquí abajo antes de continuar usando la plataforma.</span>
            </div>
          </div>
        )}

        <section className="datatable-section" style={{marginTop: '30px', maxWidth: '600px'}}>
          <div className="datatable-header" style={{borderBottom: '1px solid #eee', paddingBottom: '15px'}}>
            <h2>Tus Datos Registrados</h2>
          </div>
          <div style={{padding: '20px'}}>
            <p><strong>RUT:</strong> {user.rut || 'No especificado'}</p>
            <p><strong>Nombre:</strong> {user.nombre}</p>
            <p><strong>Correo Electrónico:</strong> {user.email}</p>
            <p><strong>Rol en el Sistema:</strong> <span className="badge category-badge" style={{background: '#6c757d', color: 'white'}}>{user.rol.toUpperCase()}</span></p>
          </div>
        </section>

        <section className="datatable-section" style={{marginTop: '30px', maxWidth: '600px', borderLeft: '4px solid #0d6efd'}}>
          <div className="datatable-header">
            <h2 style={{color: '#0d6efd'}}>Cambiar mi Contraseña por Correo</h2>
          </div>
          <div style={{padding: '20px'}}>
            <p style={{marginBottom: '15px', color: '#555', fontSize: '14px', lineHeight: '1.5'}}>
              Por seguridad, la modificación de credenciales requiere re-validación. 
              Ingresa tu <strong>RUT de registro</strong> y te enviaremos instantáneamente un enlace especial a tu correo <b>{user.email}</b> para que puedas restablecer tu clave de acceso tú mismo/a validando tu identidad de manera segura.
            </p>
            <form onSubmit={handleSolicitarCambio}>
              <button 
                type="submit" 
                className="btn-primary" 
                disabled={isRecovering}
                style={{padding: '12px 24px', margin: 0, background: '#20c997', border: 'none', borderRadius: '5px', fontSize: '15px'}}
              >
                {isRecovering ? 'Generando enrutamiento...' : 'Solicitar Enlace de Cambio Seguro'}
              </button>
            </form>
            {mensaje && <div style={{marginTop: '15px', padding: '10px', background: '#e6f4ea', color: '#137333', borderRadius: '4px', fontSize: '14px'}}>{mensaje}</div>}
          </div>
        </section>

      </main>
    </div>
  );
};

export default Perfil;
